// ========================
// Core Imports
// ========================
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// ========================
// Global Layout Components
// ========================
import Header from "./components/Header";
import Footer from "./components/Footer";

// ========================
// Page Routes
// ========================
import Homepage from "./pages/Homepage";
import Company from "./pages/Company";
import Plants from "./pages/Plants";
import RMC from "./pages/RMC";
import Contact from "./pages/Contact";

// ========================
// App Component
// ========================
const App = () => {
  return (
    <Router>
      {/* Global Site Header */}
      <Header />

      {/* Route Definitions */}
      <Routes>
        <Route path="/" element={<Homepage />} />
      </Routes>
       <Routes>
        <Route path="/company" element={<Company />} />
      </Routes>
       <Routes>
        <Route path="/plants" element={<Plants />} />
      </Routes>
       <Routes>
        <Route path="/rmc" element={<RMC />} />
      </Routes>
       <Routes>
        <Route path="/contact" element={<Contact />} />
      </Routes>


      {/* Global Site Footer */}
      <Footer />
    </Router>
  );
};

export default App;
